'use strict';

var _commonjsHelpers = require('./_commonjsHelpers-755157d3.js');

var HYDRATE_TRACK_NAME = 'hydrate';
var HYDRATE_ROOT_TRACK_NAME = 'hydrateRoot';
var NEW_RELIC_ACTION_NAME = 'NordicHydration';
var PERFORMANCE_MARK_HYDRATE = 'hydrateStart';
var PERFORMANCE_MARK_HYDRATE_ROOT = 'hydrateRootStart';
var PERFORMANCE_MEASURE_COMPLETE = 'hydrateComplete';
var PERFORMANCE_MEASURE_NAME = 'nordic-hydration';
var constants = {
  HYDRATE_TRACK_NAME: HYDRATE_TRACK_NAME,
  HYDRATE_ROOT_TRACK_NAME: HYDRATE_ROOT_TRACK_NAME,
  NEW_RELIC_ACTION_NAME: NEW_RELIC_ACTION_NAME,
  PERFORMANCE_MARK_HYDRATE: PERFORMANCE_MARK_HYDRATE,
  PERFORMANCE_MARK_HYDRATE_ROOT: PERFORMANCE_MARK_HYDRATE_ROOT,
  PERFORMANCE_MEASURE_COMPLETE: PERFORMANCE_MEASURE_COMPLETE,
  PERFORMANCE_MEASURE_NAME: PERFORMANCE_MEASURE_NAME
};
var constants$1 = _commonjsHelpers.getDefaultExportFromCjs(constants);

exports.constants = constants;
exports.constants$1 = constants$1;
